import { gql } from "@apollo/client";

export const FOREIGN_EXCEL_FILE_UPLOAD = gql`
mutation generateExcelUploadUrl($input: ExcelUploadInput!) {
  generateExcelUploadUrl(input: $input) {
    uploadUrl
    file {
      id
      title
      category
      description
      fileUrl
      fileName
      createdAt
    }
  }
}
`